<template>
  <div class="content">
    <div class="back" @click="backBtn">
      <i></i>
      <span>返回</span>
    </div>
    <!-- 试题得分详情 -->
    <div class="ItemDetails">
      <span
        >姓名：{{ this.$parent.$children[1].answerDetailParam.RealName }}</span
      >
      <span
        >试卷名称：{{
          this.$parent.$children[1].answerDetailParam.ExamName
        }}</span
      >
      <el-button type="primary" icon="el-icon-refresh" @click="reExam()"
        >重新考试</el-button
      >
      <div class="firstTable">
        <el-table
          :data="infoData"
          border
          style="width: 100%; margin-top: 20px"
          :row-class-name="tableRowClassName"
          :header-cell-style="{
            'background-color': '#8FCBFF',
            color: '#333333',
            height: '60px',
            border: '1px solid #D8EDFFFF',
            textAlign: 'center',
          }"
          v-loading="isLoading"
        >
          <el-table-column label="题型（分值）" align="center" fixed>
            <template slot-scope="scope">
              {{ scope.row.topic }}
            </template>
          </el-table-column>

          <el-table-column
            v-for="(item, index) in infoFieldData"
            :key="index"
            :prop="item.prop"
            :label="
              item.Style +
              '（' +
              item.TotalScore +
              (item.Style == '总分' ? '分' : '题') +
              '）'
            "
            :width="item.width"
            align="center"
          >
            <template slot-scope="scope">
              <!-- {{index}} -->
              <p v-if="index == 0">{{ scope.row[index + 1] }}</p>
              <p v-if="index">{{ scope.row[index + 1] }}</p>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="AllQuestions">
      <div class="name">全部试题</div>
      <!-- 表格内容 -->
      <div class="questionTable">
        <el-table
          :data="getData"
          style="width: 100%"
          :row-class-name="tableRowClassName"
        >
          <el-table-column label="序号" type="index" width="60" align="center"
            ><template slot-scope="scope">
              <span>{{ (currentPage - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            v-for="(item, index) in formColumns"
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            height="150"
            label-height="50"
            align="center"
          >
            <template slot-scope="scope">
              <p v-if="index == 0">{{ scope.row.PaperTestStyle }}</p>
              <p v-if="index == 1">{{ scope.row.TestJSON }}</p>
              <p v-if="index == 2">{{ scope.row.Answer }}</p>
              <p v-if="index == 3">
                {{ !scope.row.UserAnswer ? "未答" : scope.row.UserAnswer }}
              </p>
              <p v-if="index == 4">{{ scope.row.Score }}</p>
              <p v-if="index == 5">{{ scope.row.UserScore }}</p>
              <p v-if="index == 6">
                <span
                  v-if="scope.row.IsRight == 0"
                  style="color: green"
                  class="iconfont icon-dui"
                ></span>
                <span
                  v-else-if="scope.row.IsRight == 1"
                  style="color: red"
                  class="iconfont icon-cuo"
                ></span>
                <span v-else>未答</span>
              </p>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div class="footBox">
          <div class="footPage">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              :page-sizes="pagesizesArr"
              layout="prev, pager, next, sizes, jumper"
              :total="total"
              class="pagination"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 重新考试 -->
    <div class="reExamBox">
      <el-dialog title="温馨提示" :visible.sync="dialogReExamVisible">
        <img src="@/assets/Exam/group.png" alt="" /><span
          >注意！此操作不可逆</span
        >
        <p>
          确认后此考生本场考试数据将被清除，考生须在规定的时间内重新参加考试
        </p>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogReExamVisible = false">取 消</el-button>
          <el-button type="primary" @click="ReExamine">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  studentExamTest,
  studentExamInfo,
  clearExamHistory,
} from "@/services/examManager.js";
import eventBus from "@/utils/eventBus.js";

export default {
  name: "answerDetail",
  props: ["changes"],
  data() {
    return {
      currentPage: 1, //  当前页数
      pageSize: 10,
      pagesizesArr: [5, 10, 20, 50, 100],
      total: 100,
      // 重新考试弹框状态
      dialogReExamVisible: false,
      // 表格数据源
      getData: [],
      formColumns: [
        {
          prop: "PaperTestStyle",
          label: "题型",
        },
        {
          prop: "TestJSON",
          label: "题干",
          width: "500px",
        },
        {
          prop: "Answer",
          label: "正确答案",
        },
        {
          prop: "UserAnswer",
          label: "考生答案",
        },
        {
          prop: "Score",
          label: "分值",
        },
        {
          prop: "UserScore",
          label: "得分",
        },
        {
          prop: "IsRight",
          label: "对错",
        },
      ],
      // 题型分值字段
      infoFieldData: [],
      // 题型分值数据
      infoData: [],
      // 考生信息
      examOBj: {
        userName: "",
        RealName: "",
        // 考生ID
        sudentUserID: 0,
        // 考试ID
        examID: 0,
        // 试卷名称
        ExamName: "",
        isLoading: true,
      },
    };
  },
  methods: {
    backBtn() {
      this.$parent.changes(1);
    },

    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },

    // 显示条数
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.studentExamTests();
    },

    // 分页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.studentExamTests();
    },

    // 重新考试
    reExam() {
      this.dialogReExamVisible = true;
    },

    handlePageData(arrData) {
      this.getData = this.getData.map((item) => {
        return item;
      });
    },

    // 全部试题数据
    async studentExamTests() {
      this.isLoading = true;
      //获取传入的参数
      let answerDetailParam = this.$parent.$children[1].answerDetailParam;
      //调用接口
      const examTestParam = {};
      this.UtilFun(examTestParam);
      examTestParam.examID = answerDetailParam.ExamID;
      examTestParam.sudentUserID = answerDetailParam.SudentUserID;
      examTestParam.pageIndex = this.currentPage - 1;
      examTestParam.eachPageNum = this.pageSize;
      console.log(examTestParam, "试题请求数据");
      const { data } = await studentExamTest(examTestParam);
      console.log(data, "试题返回数据");
      if (data.Status === 200) {
        this.total = data.Data.count;
        this.getData = data.Data.allTest || [];
        this.isLoading = false;
      } else {
        this.$message.error(data.Msg);
      }
    },

    // 查看试卷详情统计数据
    async studentExamInfos() {
      //获取传入的参数
      let answerDetailParam = this.$parent.$children[1].answerDetailParam;
      //构建接口入参
      const infoParams = new Object();
      this.UtilFun(infoParams);
      infoParams.examID = answerDetailParam.ExamID;
      infoParams.sudentUserID = answerDetailParam.SudentUserID;
      console.log(infoParams, "查看试卷详情统计数据请求数据");
      //请求接口
      const { data } = await studentExamInfo(infoParams);
      console.log(data, "查看试卷详情统计数据返回数据");
      if (data.Status === 200) {
        let aa = data.Data.student[0];
        let bb = data.Data.paperStyle;

        let FieldData = [];
        let Data = [{ topic: "得分" }, { topic: "正确率" }];

        if (aa) {
          FieldData.push({ Style: "总分", TotalScore: aa.TotalScore });
          Data.forEach((element) => {
            if (element.topic === "得分") {
              element["1"] = aa.Score;
            } else {
              element["1"] = (aa.Percent * 100).toFixed(2) + "%";
            }
          });
        }

        if (bb.length > 0) {
          bb.forEach((element, index) => {
            FieldData.push({
              Style: element.Style,
              TotalScore: element.TotalScore,
            });
            Data.forEach((element2) => {
              if (element2.topic === "得分") {
                element2[index + 2] = element.UserScore;
              } else {
                element2[index + 2] = (element.Percent * 100).toFixed(2) + "%";
              }
            });
          });
        }

        this.infoFieldData = FieldData;
        this.infoData = Data;
      } else {
        this.$message.error(data.Data);
      }
    },

    // 封装方法
    UtilFun(paraObj) {
      paraObj.hid = parseInt(this.$store.state.hid);
      paraObj.userID = parseInt(this.$store.state.userID);
      paraObj.guid = this.$store.state.user;
      return paraObj;
    },

    // 重新考试确定按钮
    async ReExamine() {
      //构建参数
      const examineParam = new Object();
      examineParam.studentID =
        this.$parent.$children[1].answerDetailParam.SudentUserID;
      examineParam.examID = this.$parent.$children[1].answerDetailParam.ExamID;
      this.UtilFun(examineParam);
      //调用接口
      const { data } = await clearExamHistory(examineParam);
      console.log(data, "<<========重新考试确定按钮");
      if (data.Status == 200) {
        this.$message.success("清除成功");
        //关闭弹窗
        this.dialogReExamVisible = false;
        setTimeout(() => {
          this.changes(1);
        }, 500);
      } else {
        this.$message.error(data.Data);
      }
    },
  },

  activated() {
    this.currentPage = 1;
    this.studentExamTests();
    this.studentExamInfos();
  },
  // 生命周期钩子函数
  created() {
    // 给 bus 注册事件，并接受数据
    // eventBus.$on("examDetailChange", (detailDataArr) => {
    //   this.getData = detailDataArr;
    //   this.total = detailDataArr.length;
    //   this.examOBj.RealName = detailDataArr.RealName;
    //   this.examOBj.ExamName = detailDataArr.ExamName;
    //   // console.log(detailDataArr, "66");
    // });
  },
  beforeDestroy() {
    // 1.页面销毁时，取消监听
    eventBus.$off("examDetailChange", this.handel);
  },
};
</script>

<style lang="scss" scoped>
.content {
  height: 100%;
  width: 100%;
  min-width: 1650px;
}
.back {
  border-bottom: 1px solid #f8f8f8;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  height: 44px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}

.ItemDetails {
  background-color: white;
  border-top: 1px solid #eeeeee;
  .firstTable {
    margin-left: 24px;
    padding: 30px;
  }
  span:nth-child(1) {
    width: 75px;
    height: 21px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 26px;
    color: #333333;
    opacity: 1;
    margin-left: 24px;
  }
  span:nth-child(2) {
    width: 180px;
    height: 21px;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 26px;
    color: #333333;
    opacity: 1;
    margin-left: 30px;
    margin-left: 24px;
  }
  ::v-deep .el-button {
    width: 115px;
    height: 40px;
    background: #64b5ff;
    opacity: 1;
    border-radius: 4px;
    margin-top: 25px;
    margin-left: 30px;
  }
}

// 表格内容
.AllQuestions {
  margin-top: 24px;
  background-color: white;
  .name {
    width: 72px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 26px;
    color: #333333;
    opacity: 1;
    margin-top: 21px;
    margin-left: 24px;
  }
  .questionTable {
    margin-top: 44px;
    margin-left: 24px;
    .el-button {
      font-size: 16px;
    }
    ::v-deep .el-table {
      margin-top: 10px;
    }
    ::v-deep .el-table th {
      width: 100%;
      height: 60px;
      background: #8fcbff;
      color: #333333;
      opacity: 1;
    }
    ::v-deep td > .cell {
      color: #999999;
      font-size: 15px;
    }
  }
}

::v-deep .el-table__row {
  height: 50px !important;
  td,
  th {
    padding: 0 !important;
  }
}

// 分页
.footBox {
  position: relative;
  height: 110px;
  .footPage {
    display: flex;
    position: absolute;
    right: 16px;
    bottom: 30px;
    span {
      line-height: 32px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      b {
        color: #ff0000;
      }
    }
  }
  .pagination {
    ::v-deep .el-pager {
      li {
        border: 1px solid #d9d9d9;
        margin-right: 8px;
        &.active {
          color: #ffffff;
          background-color: #409eff;
          border: none;
        }
      }
    }
    ::v-deep .el-pagination__jump {
      margin: 0px 10px 0px 0px !important;
    }
  }
}

// 弹框头部样式
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}
::v-deep .reExamBox .el-dialog {
  width: 570px;
  height: 214px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
}

::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
</style>
